import * as iconBoard from "assets/desktop/icons/game/board";
import * as iconCockFighting from "assets/desktop/icons/game/cock-fighting";
import * as iconFishing from "assets/desktop/icons/game/Fishing";
import * as iconMobileGameHome from "assets/desktop/icons/game/HomeMobile";
import * as iconCasio from "assets/desktop/icons/game/live";
import * as iconLottery from "assets/desktop/icons/game/lottery";
import * as iconNoHu from "assets/desktop/icons/game/slots";
import * as iconSport from "assets/desktop/icons/game/sport";
import * as imageBoard from "assets/desktop/images/Game/board";
import * as imageCockFighting from "assets/desktop/images/Game/cock-fighting";
import * as imageFishing from "assets/desktop/images/Game/Fishing";
import * as imageCasio from "assets/desktop/images/Game/live";
import * as imageLottery from "assets/desktop/images/Game/lottery";
import * as imageNoHu from "assets/desktop/images/Game/slots";
import * as imageSport from "assets/desktop/images/Game/sport";
export interface GameType {
  name: string;
  icon: string;
  id: string;
  image: string;
}
export interface GameList {
  categoryName: string;
  categoryId: string;
  categoryCode: string;
  icon: string;
  backgroundImage: string;
  isItemCard?: boolean; // check not sub game
  isSubGame?: boolean; // check sub game
  imageHome?: string; // image home page
  iconHome?: string; // icon home page
  desc?: string; // description home page
  col?: number; // render col provider in game page
  isBorderBottom?: boolean; // check active css bottom border
  iconHomeMobile?: string;
  iconMobile?: string;
}
export const hostGame: GameList = {
  categoryName: "HOT",
  categoryId: "HOT",
  categoryCode: "HOT",
  icon: "/v2/mobile/home/hot.png",
  backgroundImage: "",
  isItemCard: true,
  imageHome: "",
  iconHome: "/v2/mobile/home/hot.png",
  desc: "Đa dạng các Sòng Bài Nhiều Khuyến mãi hàng tuần",
  iconHomeMobile: "/v2/mobile/home/hot.png",
  iconMobile: "/v2/mobile/home/hot.png",
};
export const gameList: GameList[] = [
  {
    categoryName: "Sòng bài",
    categoryId: "live",
    categoryCode: "LC",
    icon: iconCasio.casio,
    backgroundImage: imageCasio.casioBanner,
    isItemCard: true,
    imageHome: imageCasio.casino,
    iconHome: imageCasio.iconCasino,
    desc: "Đa dạng các Sòng Bài Nhiều Khuyến mãi hàng tuần",
    iconHomeMobile: "/v2/mobile/home/live.png",
    iconMobile: "/v2/mobile/home/live.png",
  },
  {
    categoryName: "Nổ hũ",
    categoryId: "game",
    categoryCode: "SL",
    icon: iconNoHu.nohu,
    backgroundImage: imageNoHu.banner,
    isSubGame: true,
    imageHome: imageNoHu.noHu,
    iconHome: imageNoHu.iconNoHu,
    desc: "Đa dạng các Sòng Bài Nhiều Khuyến mãi hàng tuần",
    iconHomeMobile: "/v2/mobile/home/slot.png",
    iconMobile: iconMobileGameHome.slot,
  },
  {
    categoryName: "Bắn cá",
    categoryId: "fish",
    categoryCode: "FH",
    icon: iconFishing.fish,
    backgroundImage: imageFishing.banner,
    imageHome: imageFishing.fishing,
    iconHome: imageFishing.iconFishing,
    desc: "Dao diện đẹp mắt, đồ họa đỉnh cao, âm thanh sống động, gameplay độc đáo, hoàn trả cao, thỏa sức bắn.",
    iconHomeMobile: "/v2/mobile/home/fish.png",
    iconMobile: iconMobileGameHome.fishing,
  },
  {
    categoryName: "Thể thao",
    categoryId: "sport",
    categoryCode: "SB",
    icon: iconSport.sport,
    backgroundImage: imageSport.banner,
    isItemCard: true,
    imageHome: imageSport.sport,
    iconHome: imageSport.iconSport,
    desc: "Đa dạng cược, hoàn trả cao và thanh toán cực nhanh",
    iconHomeMobile: "/v2/mobile/home/sport.png",
    iconMobile: iconMobileGameHome.sport,
  },
  {
    categoryName: "Game bài",
    categoryId: "board",
    categoryCode: "BG",
    icon: iconBoard.bai,
    backgroundImage: imageBoard.banner,
    isSubGame: true,
    imageHome: imageBoard.gameBai,
    iconHome: imageBoard.iconGameBai,
    desc: "MINI GAME sáng tạo, hấp dẫn cùng chiến hắng siêu tốc và thú vị! Nâng trải nghiệm chơi game của bạn lên một tầm cao mới",
    isBorderBottom: true,
    iconHomeMobile: "/v2/mobile/home/board.png",
    iconMobile: iconMobileGameHome.bai,
  },
  {
    categoryName: "Đá gà",
    categoryId: "cock-fighting",
    categoryCode: "CF",
    icon: iconCockFighting.cockFighting,
    backgroundImage: imageCockFighting.banner,
    isItemCard: true,
    imageHome: imageCockFighting.daGa,
    iconHome: imageCockFighting.iconDaGa,
    desc: "Những trận gà đỉnh cao và đẳng cấp",
    col: 3,
    iconHomeMobile: "/v2/mobile/home/cock.png",
    iconMobile: iconMobileGameHome.cockFighting,
  },
  {
    categoryName: "Xổ số",
    categoryId: "lottery",
    categoryCode: "LT",
    icon: iconLottery.lottery,
    backgroundImage: imageLottery.banner,
    isItemCard: true,
    iconHomeMobile: "/v2/mobile/home/lottery.png",
    iconMobile: iconMobileGameHome.lottery,
  },
];
